import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    sidebarStatus: 1,
    qc: null,
    entry: null,
    order: null,
    addAgain: false,

};

export const SettingRedux = createSlice({
    name: 'setting',
    initialState,
    reducers: {
        handleSidebarStatus: (state, action) => {
            state.sidebarStatus = action.payload;
        },

        handleQc: (state, action) => {
            state.qc = action.payload;
        },

        handleEntry: (state, action) => {
            state.entry = action.payload;
        },

        handleOrder: (state, action) => {
            state.order = action.payload;
        },

        handleAddAgain: (state, action) => {
            state.addAgain = action.payload;
        },

    },
});

export const {
    handleSidebarStatus,handleAddAgain, handleQc,
    handleEntry,
    handleOrder,

} = SettingRedux.actions;

export default SettingRedux.reducer;

